import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@material-ui/core";
import React, { FunctionComponent } from "react";

export interface Skill {
  id: string;
  groupId: string;
  label: string;
  description: string;
}

export interface Properties {
  data: Array<Skill>;
}

export const ManageContentDisplaySkills: FunctionComponent<Properties> = ({
  data,
}) => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>
            <Typography>Id</Typography>
          </TableCell>
          <TableCell>
            <Typography>Group Id</Typography>
          </TableCell>
          <TableCell>
            <Typography>Label</Typography>
          </TableCell>
          <TableCell>
            <Typography>Description</Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((skill) => (
          <TableRow key={skill.id}>
            <TableCell>
              <Typography>{skill.id}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{skill.groupId}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{skill.label}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{skill.description}</Typography>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
